export default __webpack_public_path__ + "static/About-ed3450733ba5365940b6f59007bfaa08.png";